/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                 */
export const scssModules: Record<string, () => Promise<string>> =
  import.meta.glob(['../scss/*.scss'], {
    query: '?inline',
    import: 'default',
  })
